import { render, staticRenderFns } from "./IzinYearChart.vue?vue&type=template&id=4df84aa8&"
import script from "./IzinYearChart.vue?vue&type=script&lang=js&"
export * from "./IzinYearChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports